import z from 'zod';
import { emailSchema, nameSchema, phoneSchema } from '../../validation';
import { booleanSchema } from '../../common';

export const lenderContactSchema = z.object({
  name: nameSchema,
  email: emailSchema,
  phone: phoneSchema.optional(),
  receiveNewApplicationEvent: booleanSchema,
});
